import { ENUMS } from '../utils/constants';

const INITIAL_STATE = {
    deliveryGroup: {},
    routes: [],
    route: {},
    routeLocationTargets: [],
    routeLocationTarget: {},
    orders: [],
    nextPdu: false,
    order: {},
    qrCodes: [],
    filterManualCall: {},
    filter: {
        sectors: [],
        areas: [],
        allOrders: true,
        orderCode: undefined,
        routeCode: undefined,
        auxCode: undefined,
        cim: undefined,
        partnumber: undefined,
        supplierCode: undefined,
        orderType: ENUMS.eOrderType.Delivery,
        routeId: undefined,
        lockedBy: undefined,
        inicialQrCode: undefined,
        finalQrCode: undefined,
        excludeOrderGrouped: true,
        assigned: false,
        status: [
            ENUMS.eOrderStatus.Waiting.value,
            ENUMS.eOrderStatus.InProgress.value,
            ENUMS.eOrderStatus.WaitingRouteComposition.value,
            ENUMS.eOrderStatus.WaitingFinish.value
        ],
        orderItemCode: undefined,
        position: [],
        routes: []
    },
};

export default function deliveryReducer(state, action) {
    if (typeof state === 'undefined') {
        return INITIAL_STATE;
    }

    switch (action.type) {
        case 'DELIVERY_FILTER':
            return {
                ...state,
                filter: action.filter,
            };
        case 'DELIVERY_SELECT_ORDER_GROUP':
            return {
                ...state,
                deliveryGroup: action.deliveryGroup,
            };
        case 'RESET_DELIVERY_GROUP':
            return {
                ...state,
                deliveryGroup: INITIAL_STATE.deliveryGroup
            };
        case 'DELIVERY_SELECT_ORDERS':
            return {
                ...state,
                orders: action.orders,
            };
        case 'SET_NEXT_PDU': {
            return {
                ...state,
                nextPdu: action.nextPdu,
            };
        }
        case 'DELIVERY_SELECT_ORDER':
            return {
                ...state,
                order: action.order,
            };
        case 'UPDATE_DELIVERY_GROUP':
            const deliveryGroup = {};
            Object.assign(deliveryGroup, action.deliveryGroup);

            return {
                ...state,
                deliveryGroup: deliveryGroup,
            };
        case 'UPDATE_DELIVERY_MISSION_STATUS': {
            const ordersUp = [];
            Object.assign(ordersUp, state.orders);
            const order = ordersUp.find((f) => f.items.find((m) => m.orderItemId === action.orderItemId));
            const missionUpdate = order.items.find((m) => m.orderItemId === action.orderItemId);
            if (missionUpdate) {
                missionUpdate.status = action.status;
            }
            return {
                ...state,
                orders: ordersUp
            };
        }
        case 'UPDATE_DELIVERY_ORDER_STATUS': {
            const orderUpdate = state.order;
            orderUpdate.status = action.status;
            return state;
        }
        case 'RESET_DELIVERY_ORDER':
            return {
                ...state,
                order: INITIAL_STATE.order
            };
        case 'RESET_DELIVERY_ORDERS':
            return {
                ...state,
                orders: INITIAL_STATE.orders
            };
        case 'DELIVERY_UPDATE_ORDER': {
            const orders = state.orders;
            if (orders != null) {
                const order = (orders?.items ? orders?.items : orders).find((o) => o.orderId === action.order.orderId);
                if (order) {
                    if (action.order.status !== ENUMS.eOrderStatus.Canceled.value
                        && action.order.status !== ENUMS.eOrderStatus.Finished.value
                        && action.order.status !== ENUMS.eOrderStatus.ManuallyFinished.value) {
                        Object.assign(order, action.order);
                    } else {
                        orders.items = orders.filter((o) => o.orderId !== action.order.orderId);
                        orders.totalCount -= 1;
                    }
                }
            }
            return {
                ...state,
                orders
            };
        }
        case 'DELIVERY_QRCODES':
            return {
                ...state,
                qrCodes: action.qrCodes,
            };
        case 'DELIVERY_ROUTES':
            return {
                ...state,
                routes: action.routes,
            };
        case 'SET_ROUTE':
            return {
                ...state,
                route: action.route,
            };
        case 'DELIVERY_ROUTE_LOCATIONTARGETS':
            return {
                ...state,
                routeLocationTargets: action.routeLocationTargets

            };
        case 'SET_ROUTE_LOCATIONTARGET':
            return {
                ...state,
                routeLocationTarget: action.routeLocationTarget

            };
        case 'SET_FILTER_MANUAL_CALL':
            return {
                ...state,
                filterManualCall: action.filter

            };
        default:
            return state;
    }
}
